import React from 'react'
import Header from '../../../../shared/sections/Header'
import FirstView from '../../../../shared/sections/FirstView'
import { zenkokuConfig } from '../../config'
import styles from './ZenkokuSpLandingPage.module.css'
import VerticalEntryForm from '../../../../shared/forms/VerticalEntryForm'
import { StepProvider } from '@/components/Context/StepContext'
import { ZenkokuSpLandingPageProps } from './types'
import { useJobsData } from '../../../../shared/hooks/useJobsData'
import { useConfigWithDynamicData } from '../../../../shared/hooks/useConfigWithDynamicData'
import { useAbTestGtm } from '@/components/utils/abTest'
import Footer from '../../../../shared/sections/Footer'

const ZenkokuSpLandingPage: React.FC<ZenkokuSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()
    const { jobs, mapping, error } = useJobsData(zenkokuConfig)

    const configWithDynamicData = useConfigWithDynamicData({
        areaConfig: zenkokuConfig,
        jobs,
        mapping
    })

    if (error) {
        console.error('求人データの読み込みエラー:', error)
    }

    return (
        <div className={styles.zenkokuSpLandingPage}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header
                    id='renewal_top'
                    dataViewLabel={dataViewLabel('HD')}
                />
                <FirstView dataViewLabel={dataViewLabel('CT_FirstView')}/>
                <VerticalEntryForm
                    prefectures={prefectures}
                    config={configWithDynamicData}
                />
                <Footer />
            </StepProvider>
        </div>
    )
}

export default ZenkokuSpLandingPage